import { NavLink } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { BreadCrampWrapper } from "./BreadCrump.styled";
import { sliderArrowRight } from "../../assets/img/sliderArrowRight";
import { useLocation } from "react-router-dom";

export const BreadCrump = () => {
  const breadcrumbs = useBreadcrumbs();
  const location = useLocation();

  let whiteText = location.pathname.includes("/collections/") || location.pathname.includes("/creators/");

  return (
    <BreadCrampWrapper whiteText={whiteText}>
      {breadcrumbs.map(({ match, breadcrumb }, i) => (
        <>
          <NavLink key={i} to={match.pathname}>
            {breadcrumb}
          </NavLink>
          {breadcrumbs.length > i + 1 && sliderArrowRight()}
        </>
      ))}
    </BreadCrampWrapper>
  );
};
